import type { ReactNode } from "react";
import { StyleSheet, Text, View } from "react-native";

import {
  fonts,
  radii,
  spacing,
  typography,
  useThemedStyles,
  type ThemeColors,
} from "~/styles/theme";

export function Badge({
  children,
  tone = "neutral",
}: {
  children: ReactNode;
  tone?: "neutral" | "mint" | "danger" | "warning" | "success";
}) {
  const { stylesheet, toneStyles } = useThemedStyles(makeStyles);
  return (
    <View style={[stylesheet.badge, toneStyles[tone].container]}>
      <Text style={[stylesheet.label, toneStyles[tone].label]}>{children}</Text>
    </View>
  );
}

const makeStyles = (colors: ThemeColors) => {
  const stylesheet = StyleSheet.create({
    badge: {
      alignSelf: "flex-start",
      paddingHorizontal: spacing.s,
      paddingVertical: 3,
      borderRadius: radii.pill,
    },
    label: {
      fontFamily: fonts.semibold,
      fontSize: typography.xs.fontSize,
      lineHeight: typography.xs.lineHeight,
    },
  });
  const toneStyles = {
    neutral: {
      container: { backgroundColor: colors.surface },
      label: { color: colors.mutedForeground },
    },
    mint: {
      container: { backgroundColor: colors.primarySurface },
      label: { color: colors.primaryHover },
    },
    success: {
      container: { backgroundColor: colors.successSurface },
      label: { color: colors.primaryHover },
    },
    warning: {
      container: { backgroundColor: colors.dangerSurface },
      label: { color: colors.danger },
    },
    danger: {
      container: { backgroundColor: colors.dangerSurface },
      label: { color: colors.danger },
    },
  } as const;
  return { stylesheet, toneStyles };
};
